module.exports = __webpack_public_path__ + "static/media/1.45ff9a6c.jpg";